import { IconChevronRight, IconChevronLeft } from '@paro.io/base-icons'
import React from 'react'
import { Link } from '../Link'

interface BreadcrumbProps {
  className?: string
  paths: {
    url: string
    label: string
    id?: number
  }[]
}

export const Breadcrumb = ({ className, paths }: BreadcrumbProps) => {
  const isLast = paths.length - 1
  const isPrevious = paths.length - 2
  return (
    <ul className={`flex space-x-0 sm:space-x-2  ${className}`}>
      {paths.map((path, index) => {
        return (
          <li
            className={
              isPrevious === index ? 'inline ml-0' : 'hidden sm:inline ml-0'
            }
            key={index}
          >
            <Link
              color={isLast === index ? 'primary' : 'hint'}
              href={path.url}
              target='_self'
              download={false}
              size='sm'
              className={
                isLast === index ? 'no-underline hover:text-primary' : ''
              }
            >
              {isPrevious === index ? (
                <IconChevronLeft
                  size='sm'
                  className='pr-2 text-gray-400 inline sm:hidden'
                />
              ) : (
                ''
              )}
              {path.label}
              {isLast === index ? (
                ''
              ) : (
                <IconChevronRight
                  size='sm'
                  className='pl-2 text-gray-400 hidden sm:inline'
                />
              )}
            </Link>
          </li>
        )
      })}
    </ul>
  )
}
